import React from 'react';

const DishRecipeImageBlock = ({ dish }) => {
  const imageSrc = dish?.image || '/assets/icons/svg/default-image-placeholder.svg';
  const altText = dish?.name || 'Dish Image';

  return (
    <div className="rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm w-full">
      <div className="w-full aspect-square bg-gray-100">
        <img
          src={imageSrc}
          alt={altText}
          className="w-full h-full object-cover"
          onError={(event) => {
            event.currentTarget.src = '/assets/icons/svg/default-image-placeholder.svg';
          }}
        />
      </div>
    </div>
  );
};

export default DishRecipeImageBlock;

